export enum QuizType {
  Quiz = 'QUIZ',
  Survey = 'SURVEY',
}
